import React from 'react'
import Header from '../Component/Header'
import contactImg from '../Images/image copy 5.jpg'

const Contact = () => {
    return (
        <div>
            <Header />
            <section className="contact-section">
                <div className="contact-overlay">
                    <div className="contact-wrapper">
                        <div className="contact-left">
                            <img src={contactImg} alt="Handmade Rugs" />
                        </div>

                        <div className="contact-right">
                            <h2>
                                Reach out to us for<br />
                                viewing our<br />
                                handmade rugs
                            </h2>

                            <p className="address">
                                H-113 Malviya Industrial Area,<br />
                                Near Apex Circle<br />
                                Jaipur (India)<br />
                                Pincode 302017
                            </p>

                            <h3>Opening hours</h3>
                            <div className="divider"></div>
                            <p>10.00 AM to 6.00 PM</p>

                            <div className="contact-info">
                                <p>royalrugs@hotmail.com</p>
                                <p>+91 982 909 4961</p>
                                <p>+91 941 407 2185</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contact